import Link from 'next/link';
import { memo } from 'react';

import { type SettingsNavItem } from '~/components/v2/components/workspace/settings-nav/settingsNavTypes';
import { SubSideNavItemLabel } from '~/components/v2/components/workspace/sub-side-nav/item/SubSideNavItemLabel';
import { SubSideNavItemPrefix } from '~/components/v2/components/workspace/sub-side-nav/item/SubSideNavItemPrefix';
import { WorkspaceSidebarNavigationItem } from '~/components/v2/components/workspace/workspace-sidebar/WorkspaceSidebarNavigationItem';

export type SettingsSubSideNavItemProps = {
  item: SettingsNavItem;
};

export const SettingsSubSideNavItem = memo(({ item }: SettingsSubSideNavItemProps) => {
  const Icon = item.icon;

  return (
    <WorkspaceSidebarNavigationItem
      appearance="subNav"
      asChild
      className="px-2.5"
      data-id={item.id}
      data-item-id={item.id}
      data-selected={item.isActive}
      data-testid="SETTINGS_SUB_SIDE_NAV_ITEM"
    >
      <Link href={item.href}>
        <SubSideNavItemPrefix className="ads:text-icon-default text-gray-10 ads:group-data-[selected=true]/workspace-sidebar-navigation-item:text-icon-emphasis group-data-[selected=true]/workspace-sidebar-navigation-item:text-gray-12">
          <Icon color="currentColor" size="sm" />
        </SubSideNavItemPrefix>
        <SubSideNavItemLabel>{item.name}</SubSideNavItemLabel>
      </Link>
    </WorkspaceSidebarNavigationItem>
  );
});

SettingsSubSideNavItem.displayName = 'SettingsSubSideNavItem';
